export const restoreFiltersStructure = [
    // ---------------------- Name & Path ----------------------
    {
        CategoryName: "Name & Path",
        Label: "Directory name contains",
        Key: "directory_contains",

        Type: "text",
    },
    {
        CategoryName: "Name & Path",
        Label: "Name contains",
        Key: "name_contains",

        Type: "text",
    },
    // ---------------------- Type & Size ----------------------
    {
        CategoryName: "Type & Size",
        Label: "File type group",
        Key: "group_ids",

        Type: "multiselect",
        Options: {
            EntrySource: 'file_groups', // retrieving file_group from FilterSupportData internal state. Expected to be an array of dicts
            // EntrySource: [{'id':1,'mnemonic':'Option 1'},{'id':2,'mnemonic':'Option 2'}], // using data provided in here as a list of dicts
            EntryDisplay: "name", // the property from the above dict to be displayed in the select options
            EntryValue: "id", // the property from the above dict to be used as the value in the select options
        },
    },
    {
        CategoryName: "Type & Size",
        Label: "File type",
        Key: "type_ids",

        Type: "multiselect",
        Options: {
            EntrySource: 'file_types',
            EntryDisplay: "mnemonic",
            EntryValue: "id",
            EntryValidation: {
                // this filter option will be valid only if the value of LocalProperty (Eg. 'file_group_ids') will be in the ValidationDependency values. (Eg. field 'group_ids' -> property 'id')
                // if 'group_ids' is not selected, means All and this filter is considered valid
                Dependency: "group_ids",
                DependencyType: "in_larger_category",
                LocalProperty: "file_group_ids",
                DependencyProperty: "id"
            }
        }
    },
    {
        CategoryName: "Type & Size",
        Label: "Minimum file size",
        Key: "size_minimum",

        Type: "sizeInput",
        Options: {
            EntryValidation: {
                Dependency: "size_maximum",
                DependencyType: "upper_limit"
            }
        }
    },
    {
        CategoryName: "Type & Size",
        Label: "Maximum file size",
        Key: "size_maximum",

        Type: "sizeInput",
        Options: {
            EntryValidation: {
                Dependency: "size_minimum",
                DependencyType: "lower_limit"
            }
        }
    },
    // ---------------------- Backup ----------------------
    {
        CategoryName: "Backup",
        Label: "Backup Software",
        Key: "backup_software_ids",

        Type: "multiselect",
        Options: {
            EntrySource: 'backup_software',
            EntryDisplay: "name",
            EntryValue: "id"
        }
    },
    {
        CategoryName: "Backup",
        Label: "Backed-up since",
        Key: "backed_up_since",

        Type: "dateInput",
        Options: {
            EntryValidation: {
                Dependency: "backed_up_until",
                DependencyType: "upper_limit"
            }
        }
    },
    {
        CategoryName: "Backup",
        Label: "Backed-up until",
        Key: "backed_up_until",

        Type: "dateInput",
        Options: {
            EntryValidation: {
                Dependency: "backed_up_since",
                DependencyType: "lower_limit"
            }
        }
    },
    {
        CategoryName: "Backup",
        Label: "Retention Policy",
        Key: "retention_policy_ids",

        Type: "multiselect",
        Options: {
            EntrySource: 'retention_policies',
            EntryDisplay: "label",
            EntryValue: "id"
        }
    },
    // Next filter turn off as endpoint does not support it yet
    // {
    //     CategoryName: "Backup",
    //     Label: "Most recent only",
    //     Key: "most_recent_only",
    //
    //     Type: "toggleInput",
    //     Options: {defaultValue: false}
    // },
    // ---------------------- Host, group & user ----------------------
    {
        CategoryName: "Host",
        Label: "Host Types",
        Key: "host_type_ids",

        Type: "multiselect",
        Options: {
            EntrySource: 'host_types',
            EntryDisplay: "name",
            EntryValue: "id"
        }
    },
    {
        CategoryName: "Host",
        Label: "Hosts",
        Key: "host_ids",

        Type: "multiselect",
        Options: {
            EntrySource: 'hosts',
            EntryDisplay: "name",
            EntryValue: "id",
            EntryValidation: {
                Dependency: "host_type_ids",
                DependencyType: "in_larger_category",
                LocalProperty: "host_type_id",
                DependencyProperty: "id"
            }
        }
    },
];